import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Store } from '@ngxs/store';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { StackableNotification } from 'ng2-app/store/stackable-notifications/StackableNotification.dsi';
import { StackableNotificationsState } from 'ng2-app/store/stackable-notifications/StackableNotifications.state';
import {
  StackableNotificationCardComponent
} from 'ng2-app/notifications/stackable-notifications/stackable-notification-card.component';

@Component({
  selector: 'app-stackable-notifications-manager',
  templateUrl: './stackable-notifications-manager.component.html',
  standalone: false
})
export class StackableNotificationsManagerComponent implements AfterViewInit, OnDestroy {

  maxNotifications = 3;
  temporaryNotifications$: Observable<StackableNotification[]> = this.store.select( StackableNotificationsState.temporaryNotifications );
  permanentNotifications$: Observable<StackableNotification[]> = this.store.select( StackableNotificationsState.permanentNotifications );
  @ViewChildren(StackableNotificationCardComponent) snackbarCardsVC: QueryList<StackableNotificationCardComponent>;
  destroyed$ = new Subject<boolean>();
  viewReady$ = new BehaviorSubject<boolean>(false);
  viewHeight: number;

  constructor(
    private store: Store,
  ) {}

  ngAfterViewInit() {
    this.setupCardsWatch();
    this.viewHeight = window?.visualViewport?.height || 0;
  }

  setupCardsWatch(failures = 0) {
    if(failures > 3) {
      console.error('Failed to setup Snackbar/Notifications manager. @ViewChildren never initialized.');
      return;
    }

    if(!!this.snackbarCardsVC) {
      this.snackbarCardsVC.changes.subscribe( cards => {
        const excessCards = cards.length > this.maxNotifications
          && cards.filter( card => !card.notification.permanent && !card.expired ).length > this.maxNotifications;
        if(excessCards) {
          this.snackbarCardsVC.find(card => !card.expired)?.expire();
        }
      });

      // Defer flipping viewReady$ out of ngAfterViewInit's change-detection pass.
      setTimeout(() => {
        this.viewReady$.next(true);
        this.viewReady$.complete();
      });
      return;
    }

    setTimeout(() => this.setupCardsWatch(++failures));
  }

  track(index, item) {
    return item.identifier;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
